import { NgModule } from '@angular/core';
import { BaseModule } from '../shared/base.module';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TranslationsComponent } from './translations.component';
import { TranslationsRoutesModule } from './translations.routes';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from '../shared/pagination/pagination.module';
import { DialogModule } from '../dialog/dialog.module';
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';
import { MATERIALS } from '../app.materials';

@NgModule({
    imports: [
        BaseModule,
        TranslationsRoutesModule,
        MATERIALS,
        TypeaheadModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule,
        DialogModule,
        BreadcrumbModule
    ],
    declarations: [TranslationsComponent]
})
export class TranslationsModule { }
